import { PartnerPricingdatabystageActions } from "./action";

const initialState = {
  partnerPricingDataWithStage: [],
  error: "",
};

const partnerPricingDataWithStageReducer = (state = initialState, action) => {
  switch (action.type) {
    case PartnerPricingdatabystageActions.PARTNER_PRICING_DATA_BY_STAGE_SUCCESS:
      return {
        ...state,
        partnerPricingDataWithStage: action.payload,
      };

    case PartnerPricingdatabystageActions.PARTNER_PRICING_DATA_BY_STAGE_ERROR:
    return {    
        ...state,
        partnerPricingDataWithStage: [],
        error: action.payload,
        };

    default:
      return {
        state,
      };
  }
};

export default partnerPricingDataWithStageReducer;